import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IBlogInlineImagePayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  image_url?: string;
  mobile_image_url?: string;
  alt_text?: string;
  caption?: string;
  caption_text_color?: string;
  caption_alignment?: string;
  border_radius_px?: number;
  status?: boolean;
}

export async function createBlogInlineImage(
  payload: Partial<IBlogInlineImagePayload>,
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BLOG_INLINE_IMAGE.CREATE,
      payload,
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBlogInlineImage(
  id: number,
  payload: Partial<IBlogInlineImagePayload>,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BLOG_INLINE_IMAGE.UPDATE(id),
      payload,
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
